import { Form, Spinner } from 'react-bootstrap';
import Layout2 from '../layouts/Layout2';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../App.css';

const Transaction = () => {
    const endpointURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    
    const handleSearch = (e) => {
        e.preventDefault();
        fetchData();
    }
    
    const fetchData = async () => {
        setIsLoading(true);
        const paramArray = {
            "from": from,
            "to": to
        };
        try {
            const response = await fetch(endpointURL + "/api/v1/getTransactions", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
                body: JSON.stringify(paramArray),
            });
            if (!response.ok) {
                console.log("error resp");
            }
            const result = await response.json();
            if (result.status == true) {
                setFrom(result.date.from);
                setTo(result.date.to);
                setData(result.data);
            } else {
                console.log("response fail");
            }
        } catch (error) {
            console.log("error catch")
        }
        setIsLoading(false);
    }
    
    const viewTransaction = (data) => {
        navigate('/transaction-view', { state: data });
    }
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
        fetchData();
    }, []);
    
    return (
        <>
            <Layout2 pageType="မှတ်တမ်းများ">
                <Helmet>
                    <title>မှတ်တမ်းများ</title>
                </Helmet>
                <div className="transaction-container">
                    <Form className="transaction-search-form" onSubmit={handleSearch}>
                        <div className="transaction-form-row">
                            <Form.Group className="transaction-form-group">
                                <Form.Label className="transaction-label">From:</Form.Label>
                                <Form.Control
                                    type="date"
                                    defaultValue={from}
                                    onChange={(e) => setFrom(e.target.value)}
                                    className="transaction-input"
                                />
                            </Form.Group>
                            <Form.Group className="transaction-form-group">
                                <Form.Label className="transaction-label">To:</Form.Label>
                                <Form.Control
                                    type="date"
                                    defaultValue={to}
                                    onChange={(e) => setTo(e.target.value)}
                                    className="transaction-input"
                                />
                            </Form.Group>
                        </div>
                        <Form.Group style={{ textAlign: 'center' }}>
                            <button className="transaction-search-btn" type="submit">
                                <i className='lni lni-search'></i>
                                ရှာမည်
                            </button>
                        </Form.Group>
                    </Form>

                    {
                        isLoading ?
                            <div className="transaction-loading">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>လုပ်ဆောင်နေသည်...ခဏစောင့်ပါ</p>
                            </div>
                            :
                            data.length > 0 ?
                                <div className="transaction-list">
                                    {data.map((list) => (
                                        <div key={list.id} onClick={(e) => viewTransaction(list)} className="transaction-item">
                                            <div className="transaction-item-header">
                                                <img src={`./${list.image}`} className="transaction-logo" alt="Logo"></img>
                                                <div className="transaction-info">
                                                    <div className="transaction-name">{list.pay_name}</div>
                                                    <div className="transaction-badges">
                                                        {(list.status_id == "2" && list.credit == "0") || (list.status_id == "3" && list.credit == "0") ?
                                                            <span className="transaction-badge paid">Paid</span> : ""}
                                                        {(list.status_id == "2" && list.credit == "1") || (list.status_id == "3" && list.credit == "1") ?
                                                            <span className="transaction-badge credit">Credit</span> : ""}
                                                    </div>
                                                </div>
                                                <div className="transaction-amount">{list.kyat} MMK</div>
                                            </div>
                                            <div className="transaction-details">
                                                <span className="transaction-date">{list.date} {list.time}</span>
                                                <span className={`transaction-status ${list.status_id == 1 ? 'pending' : 'completed'}`}>
                                                    {list.status_name}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <div className="transaction-empty">မှတ်တမ်းမရှိပါ...</div>
                    }
                </div>
            </Layout2>
        </>
    );
}

export default Transaction;